import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import WebFont from 'webfontloader';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './icons';
import 'normalize.css/normalize.css';
import './styles/global.scss';
import { APP_PREFIX } from './constants';
const version = process.env.REACT_APP_VERSION;
const DATA_UI_ATTR = 'data-cuf-ui-version';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

let root;
const component = (
  <BrowserRouter basename={APP_PREFIX}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </BrowserRouter>
);

// load OTC fonts
WebFont.load({
  google: {
    families: [
      'Nunito Sans:200,200i,400,400i,600,600i,700,700i,800,800i900,900i',
      'Source Serif Pro:400,700'
    ]
  }
});

if (window.location.port === '3004') {
  const rootElement = document.getElementById('root');
  rootElement.setAttribute(DATA_UI_ATTR, version);
  root = ReactDOM.createRoot(rootElement);
  root.render(component);
}


window.renderMicro = (containerId) => {
  const rootElement = document.getElementById(containerId);
  if (!rootElement) return;

  rootElement.setAttribute(DATA_UI_ATTR, version);
  root = ReactDOM.createRoot(rootElement);
  root.render(component);
};


// load pages with path without micro front end
if (window.location.pathname.includes('/company-logo')) {
  window.renderMicro('root');
}


window.unmountMicro = _ => {
  root.unmount();
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
